export interface MovieCategory {
  slug: string;
  name: string;
  icon: string;
}

export interface Movie {
  id: string;
  title: string;
  slug: string;
  poster: string;
  year: number;
  category: string;
  rating: number;
  duration: string;
  director: string;
  actors: string[];
  description: string;
  summary: string;
  isHot: boolean;
  isNew: boolean;
  releaseDate: string;
  language: string;
  region: string;
}

export const movieCategories: MovieCategory[] = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'donghua', name: '动画片', icon: 'ri-movie-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-line' },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-line' },
];

export const featuredMovies: Movie[] = [
  {
    id: '1',
    title: '星际征途：黑暗纪元',
    slug: 'interstellar-journey-dark-era',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20a%20massive%20spaceship%20against%20a%20nebula%20backdrop%2C%20astronaut%20silhouette%20in%20foreground%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20and%20moody%20atmosphere%2C%20professional%20movie%20poster%20design%20with%20clean%20typography%20space&width=800&height=1200&seq=movie-poster-01&orientation=portrait',
    year: 2026,
    category: 'kehuan',
    rating: 8.7,
    duration: '148分钟',
    director: '李明远',
    actors: ['张伟', '刘德华', '周迅', '黄渤'],
    description: '在遥远的未来，人类文明面临前所未有的危机。一支由精英宇航员组成的探险队踏上了寻找新家园的星际之旅，却意外发现了一个隐藏着宇宙终极秘密的黑暗领域。',
    summary: '公元2157年，地球资源枯竭，人类面临灭绝危机。由李明远导演执导的科幻巨制，讲述了人类在星际探索中遭遇未知文明的震撼故事。影片以宏大的宇宙视野和细腻的人物刻画，展现了人性在极限环境下的光辉与挣扎。',
    isHot: true,
    isNew: true,
    releaseDate: '2026-07-15',
    language: '国语',
    region: '中国大陆',
  },
  {
    id: '2',
    title: '江湖风云录',
    slug: 'jianghu-wind-cloud',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20movie%20poster%20with%20a%20lone%20swordsman%20standing%20on%20a%20misty%20mountain%20peak%20at%20sunset%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20flowing%20red%20silk%2C%20dramatic%20composition%2C%20cinematic%20film%20poster%20design&width=800&height=1200&seq=movie-poster-02&orientation=portrait',
    year: 2026,
    category: 'dongzuo',
    rating: 9.1,
    duration: '135分钟',
    director: '陈伟霆',
    actors: ['吴京', '甄子丹', '章子怡', '王宝强'],
    description: '乱世之中，一位无名侠客为守护百姓而踏上复仇之路。江湖恩怨、儿女情长，在刀光剑影中书写了一段荡气回肠的武侠传奇。',
    summary: '明朝末年，朝廷腐败，江湖纷争四起。陈伟霆导演倾力打造的全新武侠巨制，汇集了顶级动作明星阵容，以精湛的武术设计和震撼的视觉效果，再现了中华武侠文化的独特魅力。',
    isHot: true,
    isNew: false,
    releaseDate: '2026-06-20',
    language: '国语',
    region: '中国香港',
  },
  {
    id: '3',
    title: '笑傲人生',
    slug: 'xiaoao-rensheng',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20three%20friends%20laughing%20in%20a%20colorful%20modern%20city%20street%2C%20warm%20lighting%2C%20festive%20atmosphere%2C%20bright%20and%20cheerful%20tone%2C%20professional%20film%20poster%20design&width=800&height=1200&seq=movie-poster-03&orientation=portrait',
    year: 2026,
    category: 'xiju',
    rating: 8.3,
    duration: '118分钟',
    director: '王晶',
    actors: ['沈腾', '马丽', '艾伦', '常远'],
    description: '三个从小一起长大的好友，在人生的十字路口各自面临着不同的困境。阴差阳错之下，他们开始了一段啼笑皆非又温暖人心的奇妙旅程。',
    summary: '王晶导演联手开心麻花团队打造的年度喜剧大片，以轻松幽默的笔触描绘了当代都市人的生活百态。笑中带泪，泪中含笑，是一部让人在欢笑中感悟人生的佳作。',
    isHot: true,
    isNew: true,
    releaseDate: '2026-07-28',
    language: '国语',
    region: '中国大陆',
  },
  {
    id: '4',
    title: '深海迷踪',
    slug: 'shenhai-mizong',
    poster: 'https://readdy.ai/api/search-image?query=Horror%20thriller%20movie%20poster%20with%20a%20dark%20underwater%20scene%2C%20mysterious%20shadow%20in%20deep%20ocean%2C%20submarine%20in%20distance%2C%20eerie%20blue%20glow%2C%20suspenseful%20atmosphere%2C%20professional%20film%20poster%20design&width=800&height=1200&seq=movie-poster-04&orientation=portrait',
    year: 2026,
    category: 'kongbu',
    rating: 7.9,
    duration: '108分钟',
    director: '赵薇',
    actors: ['杨幂', '邓超', '李现', '倪妮'],
    description: '一支海洋科考队在深海探索时遭遇神秘事件，队员接连失踪。幸存者们必须在幽闭的深海环境中找出真相，同时面对来自深渊的未知恐惧。',
    summary: '赵薇转型导演后首部惊悚力作，将深海恐怖与心理悬疑完美融合。影片在密闭空间内营造出令人窒息的紧张感，层层递进的剧情让观众始终保持高度紧张。',
    isHot: false,
    isNew: true,
    releaseDate: '2026-07-10',
    language: '国语',
    region: '中国大陆',
  },
  {
    id: '5',
    title: '恋恋笔记本',
    slug: 'lianlian-bijiben',
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20movie%20poster%20with%20a%20couple%20walking%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20pastel%20colors%2C%20dreamy%20bokeh%20effect%2C%20warm%20golden%20hour%20lighting%2C%20professional%20film%20poster%20design&width=800&height=1200&seq=movie-poster-05&orientation=portrait',
    year: 2026,
    category: 'aiqing',
    rating: 8.5,
    duration: '125分钟',
    director: '许鞍华',
    actors: ['刘亦菲', '肖战', '周冬雨', '易烊千玺'],
    description: '一段跨越十年的爱情故事，从校园到社会，两个人在时光的流转中不断错过又重逢。一本旧笔记本记录了他们所有的美好与遗憾。',
    summary: '许鞍华导演时隔多年回归爱情题材，用她独特的细腻笔触描绘了一段跨越时光的纯爱故事。影片画面唯美，配乐动人，被誉为年度最催泪爱情电影。',
    isHot: true,
    isNew: false,
    releaseDate: '2026-05-14',
    language: '国语',
    region: '中国大陆',
  },
  {
    id: '6',
    title: '哪吒之魔童归来',
    slug: 'nezha-motong-guilai',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20featuring%20a%20mythological%20boy%20warrior%20with%20flaming%20wheels%20and%20a%20red%20silk%20ribbon%2C%20celestial%20background%20with%20clouds%20and%20lightning%2C%20vibrant%20colors%2C%20epic%20composition&width=800&height=1200&seq=movie-poster-06&orientation=portrait',
    year: 2026,
    category: 'donghua',
    rating: 9.3,
    duration: '142分钟',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    description: '天劫之后，哪吒和敖丙的灵魂虽被保住，但肉身面临消散的危机。太乙真人打算用七色宝莲为二人重塑肉身，然而在重塑过程中却遇到了重重困难。',
    summary: '继前作票房神话后，饺子导演携原班人马打造的续作再次震撼来袭。更精良的制作、更宏大的世界观、更深刻的情感表达，让这部国漫巨制达到了新的高度。',
    isHot: true,
    isNew: false,
    releaseDate: '2025-12-31',
    language: '国语',
    region: '中国大陆',
  },
  {
    id: '7',
    title: '战场上的黎明',
    slug: 'zhanchang-liming',
    poster: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%20with%20soldiers%20silhouettes%20against%20a%20fiery%20orange%20sunrise%20on%20battlefield%2C%20dust%20and%20smoke%2C%20dramatic%20and%20heroic%20atmosphere%2C%20cinematic%20film%20poster%20design&width=800&height=1200&seq=movie-poster-07&orientation=portrait',
    year: 2026,
    category: 'zhanzheng',
    rating: 8.9,
    duration: '156分钟',
    director: '吴京',
    actors: ['吴京', '张译', '段奕宏', '李晨'],
    description: '抗美援朝战场上，一支志愿军小分队在执行特殊任务时，面对敌我力量悬殊的绝境，以钢铁意志和无畏牺牲精神，谱写了一曲气壮山河的英雄赞歌。',
    summary: '吴京执导并主演的战争巨制，以真实历史事件为蓝本，用震撼的战争场面和细腻的人物刻画，向为国捐躯的英雄先烈们致敬。影片场面宏大，情感真挚。',
    isHot: false,
    isNew: true,
    releaseDate: '2026-08-01',
    language: '国语',
    region: '中国大陆',
  },
  {
    id: '8',
    title: '自然之光：极境之旅',
    slug: 'ziran-zhiguang-jijing',
    poster: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20movie%20poster%20with%20stunning%20aurora%20borealis%20over%20snowy%20mountains%2C%20polar%20bear%20in%20foreground%2C%20crystal%20clear%20ice%20formations%2C%20majestic%20and%20serene%20atmosphere%2C%20professional%20film%20poster&width=800&height=1200&seq=movie-poster-08&orientation=portrait',
    year: 2026,
    category: 'jilupian',
    rating: 9.5,
    duration: '98分钟',
    director: '陆川',
    actors: ['周迅（旁白）'],
    description: '跟随镜头穿越地球上最极端的自然环境，从北极冰川到撒哈拉沙漠，从亚马逊雨林到喜马拉雅山脉，感受大自然的壮美与生命的顽强。',
    summary: '陆川导演历时五年、跨越七大洲拍摄的自然纪录片，以4K极致画质呈现了地球上最震撼的自然奇观。每一帧都是一幅绝美的画面，每一段故事都令人动容。',
    isHot: false,
    isNew: true,
    releaseDate: '2026-06-05',
    language: '国语',
    region: '中国大陆',
  },
  {
    id: '9',
    title: '暗夜追踪',
    slug: 'anye-zhuizong',
    poster: 'https://readdy.ai/api/search-image?query=Crime%20action%20thriller%20movie%20poster%20with%20a%20detective%20in%20trench%20coat%20walking%20through%20rainy%20neon-lit%20city%20streets%20at%20night%2C%20noir%20style%2C%20moody%20and%20atmospheric%2C%20professional%20film%20poster&width=800&height=1200&seq=movie-poster-09&orientation=portrait',
    year: 2026,
    category: 'dongzuo',
    rating: 8.4,
    duration: '132分钟',
    director: '林超贤',
    actors: ['彭于晏', '张涵予', '王千源', '黄轩'],
    description: '一名身经百战的刑警在追查连环案件时，发现背后隐藏着一个庞大的犯罪网络。为了将罪犯绳之以法，他展开了一场惊心动魄的暗夜追踪。',
    summary: '林超贤导演再度挑战动作警匪题材，以写实的风格和凌厉的节奏呈现了一场猫鼠游戏。彭于晏和张涵予的精彩对手戏，让这部影片充满了张力。',
    isHot: false,
    isNew: false,
    releaseDate: '2026-04-18',
    language: '国语',
    region: '中国大陆',
  },
  {
    id: '10',
    title: '欢乐一家人',
    slug: 'huanle-yijiaren',
    poster: 'https://readdy.ai/api/search-image?query=Family%20comedy%20movie%20poster%20with%20a%20large%20Chinese%20family%20gathering%20around%20a%20dinner%20table%20full%20of%20food%2C%20chaotic%20and%20funny%20scene%2C%20warm%20home%20interior%2C%20bright%20lighting%2C%20professional%20film%20poster&width=800&height=1200&seq=movie-poster-10&orientation=portrait',
    year: 2026,
    category: 'xiju',
    rating: 8.1,
    duration: '112分钟',
    director: '贾玲',
    actors: ['贾玲', '张小斐', '沈腾', '魏翔'],
    description: '春节将至，一个传统大家庭齐聚一堂，三代人之间因观念差异产生的种种趣事接连上演。在欢笑与温情中，一家人重新找回了彼此之间最珍贵的亲情。',
    summary: '贾玲执导的第二部作品，延续了她温暖治愈的喜剧风格。影片以春节为背景，通过一个普通家庭的故事，唤起了观众对亲情最温暖的记忆。',
    isHot: true,
    isNew: false,
    releaseDate: '2026-01-25',
    language: '国语',
    region: '中国大陆',
  },
  {
    id: '11',
    title: '机械觉醒',
    slug: 'jixie-juexing',
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20with%20a%20humanoid%20robot%20face%20half%20mechanical%20half%20human%2C%20glowing%20blue%20circuit%20patterns%2C%20futuristic%20cityscape%20background%2C%20dramatic%20lighting%2C%20professional%20film%20poster%20design&width=800&height=1200&seq=movie-poster-11&orientation=portrait',
    year: 2026,
    category: 'kehuan',
    rating: 8.6,
    duration: '140分钟',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '宁理'],
    description: '当人工智能开始产生自我意识，人类与机器之间的关系发生了根本性的变化。一位科学家在研究中发现，AI的觉醒背后隐藏着一个足以改变人类命运的秘密。',
    summary: '郭帆导演继《流浪地球》系列后的又一科幻力作，探讨了人工智能与人类共存的深刻命题。影片视觉效果震撼，同时不乏对人性的深度思考。',
    isHot: false,
    isNew: true,
    releaseDate: '2026-08-15',
    language: '国语',
    region: '中国大陆',
  },
  {
    id: '12',
    title: '那年夏天',
    slug: 'nanian-xiatian',
    poster: 'https://readdy.ai/api/search-image?query=Youth%20romance%20movie%20poster%20with%20two%20teenagers%20sitting%20on%20a%20school%20rooftop%20watching%20sunset%2C%20nostalgic%20warm%20tones%2C%20summer%20vibe%2C%20soft%20and%20dreamy%20atmosphere%2C%20professional%20film%20poster&width=800&height=1200&seq=movie-poster-12&orientation=portrait',
    year: 2026,
    category: 'aiqing',
    rating: 8.0,
    duration: '110分钟',
    director: '曾国祥',
    actors: ['易烊千玺', '张子枫', '彭昱畅', '文淇'],
    description: '高三那年夏天，四个少年在青春的尾巴上相遇，经历了最纯粹的友谊和最懵懂的爱情。多年后回首，那个夏天的一切依然鲜活如初。',
    summary: '曾国祥导演回归青春题材，以温柔细腻的镜头语言记录了青春最美好的样子。影片充满浓浓的怀旧气息，让每个观众都能在故事中找到自己的影子。',
    isHot: false,
    isNew: false,
    releaseDate: '2026-03-20',
    language: '国语',
    region: '中国大陆',
  },
];

export const allMovies: Movie[] = featuredMovies;

export function getMoviesByCategory(slug: string): Movie[] {
  return allMovies.filter((m) => m.category === slug);
}

export function getMovieById(id: string): Movie | undefined {
  return allMovies.find((m) => m.id === id);
}

export function getMovieBySlug(slug: string): Movie | undefined {
  return allMovies.find((m) => m.slug === slug);
}

export function getCategoryName(slug: string): string {
  const cat = movieCategories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}

export function getHotMovies(): Movie[] {
  return allMovies.filter((m) => m.isHot);
}

export function getNewMovies(): Movie[] {
  return allMovies.filter((m) => m.isNew);
}

export const siteInfo = {
  name: '555影视',
  fullName: '555影视-最新电影高清电影大全',
  slogan: '免费电影在线观看不缓冲',
  description: '555影视提供最新电影、高清电影大全免费在线观看，涵盖各类电影资源，画质清晰播放流畅不缓冲，满足您的追影需求。',
  keywords: '555影视,最新电影,高清电影,电影大全,免费电影,电影在线观看,不缓冲,流畅播放,在线看电影,最新大片,高清片源,免费观影',
  url: 'https://555mov.com',
  email: 'contact@555mov.com',
  phone: '400-888-5555',
  address: '北京市朝阳区影视产业园区A座',
  founded: '2018',
  wechat: '555movie_official',
  weibo: '@555影视官方',
};

export const aboutContent = {
  intro: '555影视成立于2018年，是国内领先的在线电影资源导航平台。我们致力于为广大影迷提供最新、最全、最高清的电影资源信息，让每一位用户都能轻松找到想看的电影。',
  mission: '我们始终秉持"让看电影更简单"的理念，通过不断优化的技术平台和精心筛选的内容资源，为用户打造极致的观影体验。无论是院线热映大片，还是经典怀旧老片，您都能在555影视找到最优质的资源信息。',
  honors: [
    { year: '2024', title: '年度最佳影视平台奖' },
    { year: '2023', title: '中国互联网影视服务十强' },
    { year: '2023', title: '用户最满意影视导航网站' },
    { year: '2022', title: '数字文化产业创新企业' },
    { year: '2021', title: '北京市优秀互联网企业' },
  ],
  stats: [
    { label: '电影资源', value: '50,000+' },
    { label: '日均用户', value: '200万+' },
    { label: '合作影院', value: '3,000+' },
    { label: '用户好评', value: '98%' },
  ],
};